import { render, staticRenderFns } from "./ActivityVoteNotificationSettings.vue?vue&type=template&id=56e7c362&"
import script from "./ActivityVoteNotificationSettings.vue?vue&type=script&lang=js&"
export * from "./ActivityVoteNotificationSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports